export const ChannelTypes = [
    '',
    'webchat',
    'voice',
    'twitter',
    'instagram',
    'virtual',
    'whatsapp',
    'facebook',
    'sms',
    'email',
] as const;

export type ChannelType = (typeof ChannelTypes)[number];
